import React from 'react';
import TotalWorkersIcon from '../../../../../assets/OrgDashboard/total-number-of-workers-icon.svg';
import TotalFacilitiesIcon from '../../../../../assets/OrgDashboard/total-number-of-facilities-icon.svg';
import ActiveShiftsIcon from '../../../../../assets/OrgDashboard/active-shifts-icon.svg';
import {
  SummaryGrid,
  StyledSummaryCard,
  IconWrapper,
  SummaryInfo,
  SummaryValue,
  SummarySubtext
} from './style';
import { useSelector } from 'react-redux';
import { selectOrgDashboardData } from '../../../../../modules/orgDashboard';
import { useNavigate } from 'react-router-dom';

const SummaryCards: React.FC = () => {
  const navigate = useNavigate();
  const dashboardData = useSelector(selectOrgDashboardData);
  
  const summary = dashboardData.summary;

  const stats = [
    {
      title: 'Total No of Workers',
      value: summary?.total_workers.value || '0',
      subtext: summary?.total_workers.subtext || '0 onboarding',
      icon: TotalWorkersIcon,
      colorClass: 'green' as const,
      link: '/workers'
    },
    {
      title: 'Total no of Facilities',
      value: summary?.total_facilities.value || '0',
      subtext: summary?.total_facilities.subtext || '0 Active',
      icon: TotalFacilitiesIcon,
      colorClass: 'blue' as const,
      link: '/facilities'
    },
    {
      title: 'Active Shifts',
      value: summary?.active_shifts.value || '0',
      subtext: summary?.active_shifts.subtext || 'Today',
      icon: ActiveShiftsIcon,
      colorClass: 'light-blue' as const,
      link: '/shifts-board'
    }
  ];

  return (
    <SummaryGrid>
      {stats.map((stat, index) => (
        <StyledSummaryCard 
          key={index} 
          onClick={() => stat.link && navigate(stat.link)}
          style={{ cursor: 'pointer' }}
        >
          <IconWrapper colorClass={stat.colorClass}>
            <img src={stat.icon} alt={stat.title} width="24" height="24" />
          </IconWrapper>
          <SummaryInfo>
            <h3>{stat.title}</h3>
            <SummaryValue>{stat.value}</SummaryValue>
            <SummarySubtext>{stat.subtext}</SummarySubtext>
          </SummaryInfo>
        </StyledSummaryCard>
      ))}
    </SummaryGrid>
  );
};

export default SummaryCards;
